import { Component, OnInit, ElementRef, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { EventEmitterService } from '../../services/event-emitter/event-emitter.service';

declare var $: any;

@Component({
  selector: 'app-modal-detail-doc',
  templateUrl: './modal-detail-doc.component.html',
  styleUrls: ['./modal-detail-doc.component.scss']
})
export class ModalDetailDocComponent implements OnInit, OnChanges {
  @Input() public showModal: boolean;
  @Output() public eventClose: EventEmitter<any> = new EventEmitter();

  constructor(
    private elRef: ElementRef
  ) { }

  ngOnInit() {
    this.clickOutListener();

    EventEmitterService.get('close-modal-detail').subscribe(() => {
      this.closeModal();
    });
  }

  ngOnChanges(changes) {
    changes && changes.showModal && changes.showModal.currentValue ? this.openModal() : this.closeModal();
  }

  openModal() {
    this.elRef.nativeElement.querySelector('.modal-detail-container').classList.add('show-modal-detail');
    this.elRef.nativeElement.querySelector('.modal-detail-container').classList.remove('hide-modal-detail');
  }

  closeModal() {
    this.elRef.nativeElement.querySelector('.modal-detail-container').classList.remove('show-modal-detail');
    this.eventClose.emit(null);
  }

  clickOutListener() {
    const self = this;
    document.addEventListener('click', function(e: any) {
      if (e.target.className === 'modal-detail-mask') { self.closeModal(); }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/modal-detail-doc/modal-detail-doc.component.ts